export default "__VITE_ASSET__BOEWFB90__"